module.exports = __webpack_public_path__ + "img/home_banner2.3b1f365d.png";